import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { addConditionToDb } from 'store/localDb';
import { getCurrentUserId, addCondition } from 'store/storeValtio';
import moment from 'moment';
import './condition.css';
import { getNowISO } from 'helpers/generalHelpers';

export default function Feeling() {
  console.log('Feeling');
  const navigate = useNavigate();
  const currentUserId = getCurrentUserId();

  const [submitting, setSubmitting] = useState(false);
  const [feelingState, setFeelingState] = useState(null);
 
  const feelings = [
    {feeling: 'Hot Flash', code: ''},
    {feeling: 'Nausious', code: ''},
    {feeling: 'Dizzy', code: ''},
  ];

  useEffect(() => {
    const ms = new Array(feelings.length).fill(0);
    setFeelingState(ms);
  }, [])
  
  function handleFeeling(e) {
      //console.log('handleMood', e.target.id);
      let ix = parseInt(e.target.id);
      let ms = [...feelingState];
      //console.log(ix, ms[ix]);
      ms[ix] = ms[ix] > 0 ? 0 : 1;
      setFeelingState(ms);
  }

  const initialValues = {
    userId: currentUserId,
    date: getNowISO(),
    type: 'feeling',
    condition: '',
  };


  async function handleSubmit() {
    setSubmitting(true);
    //console.log('submit feelings');

    let f = '';
    for ( let ix=0; ix<feelingState.length; ++ix) {
        const fs = feelingState[ix];
        const feeling = feelings[ix].feeling;
        //console.log(ix, fs, feeling);
        if (fs > 0) f = f + feeling + ',';
    }
    //console.log('f', f);

    initialValues.date = getNowISO();
    initialValues.condition = f;
    console.log('addCondition', initialValues);
    await addConditionToDb(initialValues);
    addCondition(initialValues);
    setSubmitting(false);
    navigate('/historyTabs/cond');  // do this to refresh
  }

  //console.log(feelingState);

return (
    <div className='mcard'>
      <div className='mcard-header'>What is your mood?</div>
      <div className='mood flex flex-wrap mx-2'>
        <ul className='flex flex-wrap justify-around'>
          {feelings.map((f,ix) => {
            return ( 
                <li key={ix}
                  className={`${feelingState && feelingState[ix] ? 'bg-gray-300' : ''}`}
                  id={ix}
                  onClick={handleFeeling}
                >
                  {f.feeling}
                </li>
            )})
          }
        </ul>
      </div>
      <div className='mcard-title mt-10 justify-center'>
          <button
            className='hpBtn'
            onClick={handleSubmit}
            disabled={submitting}
            type='submit'
          >
            Add Feelings (Feeling)
          </button>
        </div>

    </div>
  )
}
